import { useState, useEffect } from 'react';
import { LoadBalanceUseCase } from '../../application/useCases';
import { Balance } from '../../domain/entities/SaleTransaction';

export interface BalanceResult extends Balance {
    basePrice: number | null;
}

export const useBalance = (
    vehiclePlate: string | null,
    productId: number | null,
    token: string | null
) => {
    const [balance, setBalance] = useState<BalanceResult | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!vehiclePlate || !productId || !token) {
            setBalance(null);
            return;
        }

        const loadBalance = async () => {
            try {
                setIsLoading(true);
                const useCase = new LoadBalanceUseCase();
                const result = await useCase.execute(vehiclePlate, productId, token);
                setBalance(result);
            } catch (error) {
                console.error('Error loading balance:', error);
                setBalance(null);
            } finally {
                setIsLoading(false);
            }
        };

        loadBalance();
    }, [vehiclePlate, productId, token]);

    return {
        balance,
        isLoading,
    };
};

